import React, { Fragment, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { load } from "../Actions/FavoriteProducts.action";

const FavoriteProductsIcon = ({ favoritePageUrl }) => {
 const dispatch = useDispatch();
  useEffect(() => {
    dispatch(load());
  }, []);

  const active = useSelector((state) => state.favoriteProducts.products ? state.favoriteProducts.products.length > 0 : false)
  return (<Fragment>
    {favoritePageUrl && (
      <a
        className={`favorite-products__desktop favorite-icon__icon ti-menu-icon ${
          active ? "active" : ""
        }`}
        href={favoritePageUrl}
      >
        <svg>
          {active ? (
            <use href="/ui/images/tibergs-svg/sprite/sprite.svg#heart-filled"></use>
          ) : (
            <use href="/ui/images/tibergs-svg/sprite/sprite.svg#heart"></use>
          )}
        </svg>
      </a>
    )}
  </Fragment>);
}

export default FavoriteProductsIcon;
